export var InsuranceCompany;
(function (InsuranceCompany) {
    InsuranceCompany["Allianz"] = "allianz";
    InsuranceCompany["Atradius"] = "atradius";
    InsuranceCompany["Coface"] = "coface";
})(InsuranceCompany || (InsuranceCompany = {}));
